import React from "react";
import { Fragment } from "react";

import FormSection from "./FormSection";

const FormEntrySection = (props) => {
  const {
    selectedRecord,
    values,
    handleInputChange,
    handleDateChange,
    handleSingleFileUpload,
    handleRadioButton,
    selectedAction,
    currentStep,
    handleMultiFileUpload,
    handleNumberInput,
    handleDecimalNumberInput

  } = props;

  return (
    <Fragment>
      {selectedRecord && currentStep === 2 && selectedAction === "unos" && (
        <FormSection
          handleSingleFileUpload={handleSingleFileUpload}
          handleMultiFileUpload={handleMultiFileUpload}
          handleDateChange={handleDateChange}
          handleInputChange={handleInputChange}
          values={values}
          handleNumberInput={handleNumberInput}
          handleDecimalNumberInput ={handleDecimalNumberInput}
          selectedRecord={selectedRecord}
          handleRadioButton={handleRadioButton}
        />
      )}
    </Fragment>
  );
};

export default FormEntrySection;
